import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types/response";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { ICampaignAlterationApprovalRequest } from "../../../campaigns/lib/types";
import { ALTERATIONS_LIST_QUERY_KEY } from "../constants";
import { FinanceApprovalService } from "../services/FinanceApprovalService";

export function useGetAlterationRequests(request: {
  searchQuery: string;
  status: string[];
  limit: number;
  pageNo: number;
  campaignInfluencerIds?: string[];
}, enabled: boolean) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<{ data: ICampaignAlterationApprovalRequest[]; pagination: { totalCount: number } }>
  >({
    queryKey: [...ALTERATIONS_LIST_QUERY_KEY, request],
    queryFn: () => FinanceApprovalService.searchAlterationRequests(request),
    enabled: enabled
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    alterations: data?.data?.data || [],
    totalCount: data?.data?.pagination.totalCount || 0,
    isFetching: isLoading,
    isError,
  };
}
